import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '../context/AuthContext'
import { applicationsService } from '../services/api'

export function useMyApplications() {
  const { isAuthenticated, loading: authLoading } = useAuth()
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refresh = useCallback(async () => {
    if (authLoading) return []

    if (!isAuthenticated) {
      setApplications([])
      setLoading(false)
      setError(null)
      return []
    }

    setLoading(true)
    setError(null)

    try {
      const res = await applicationsService.getSentApplications({ limit: 100 })
      const data = res?.data ?? res ?? []
      const items = Array.isArray(data) ? data : []
      setApplications(items)
      return items
    } catch (err) {
      setApplications([])
      setError(err?.message || 'Impossible de charger vos candidatures')
      return []
    } finally {
      setLoading(false)
    }
  }, [authLoading, isAuthenticated])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { applications, loading, error, refresh }
}
